Toolbar = App.loadClass "grower::classes/data/planting_rx/TruthStripToolbar"

exports.register = (module) ->
    module.factory "Grower.Services.TruthStripToolbar", ["$rootScope", "Core.Services.Map", () ->
        new exports.TruthStripToolbar(arguments...)
    ]


# This class exists as an Angular service wrapper for the
# original TruthStripToolbar class. The original toolbar
# uses lots of custom eventing, and even some knockout
# observables, which is obviously stuff that we don't want
# cluttering our controllers. This service should do it's
# best to try and hide that complexity, with a public api
# that's as "Angulary" as possible.
#
# In the "show" method, we create a brand new Toolbar each time
# this is shown, but if we have @areas that were saved from a previous
# Toolbar show'ing, then we'll add those back. This works nicely
# with going back/forth between steps in the Rx Process.
class exports.TruthStripToolbar
    constructor: (@rootScope, @map) ->
        @events = new L.MassEvents()
        @areas = []
        @uncropped_strips = []

    # Resets to a fresh toolbar configuration
    reset: () =>
        @areas = []
        @hide()


    initEvents: () ->
        @events.on [
            [App.map, ['draw:created']]
            [@toolbar, ['toolbar:shape-added', 'post-add-feature']]
        ], @_cropToField

        @events.on [
            [App.map, ['draw:point-edited', 'draw:point-removed']]
            [@toolbar, ['toolbar:shape-added', 'delete:layer-deleted']],
        ], @_updateAreas


    getMode: () =>
        return @mode

    getAreas: () =>
        return @areas

    show: () =>
        @toolbar = new Toolbar()

        # If we've got saved areas, show those
        @loadPolygons(@areas)

        @initEvents()
        @field = @map.getByName("field-boundary")?.feature

        # Initialize draw mode
        @mode = @toolbar.drawMode()

        # the draw toolbar still has some nasty KnockoutJs in it,
        # so we'll use that, but bury it so we can check the mode
        # manually on *this* object from outside places
        @toolbar.drawMode.subscribe (value) =>
            @mode = value
            @_safeApply()
        @toolbar.init()


    loadPolygons: (polys) =>
        if @toolbar?
            @toolbar.drawnItems = new L.FeatureGroup()
            for area in polys
                if area.poly_raw?
                    area.poly = L.geoJson(JSON.parse(area.poly_raw)).getLayers()[0]
                    delete area.poly_raw
                @toolbar.drawnItems.addLayer area.poly


    hide: () ->
        if @toolbar?
            @toolbar.destroy()
        @events.destroy()

    # Delete an area by removing it from the toolbar's drawn items,
    # then force the list of strips to be updated
    deleteArea: (strip) =>
        @toolbar.disableCurrent()
        @toolbar.drawnItems.removeLayer strip.poly
        @_updateAreas()

    newStrip: () ->
        @toolbar.startDrawStrip()

    # Nasty hack, because I'm do so much non-angular event driven stuff. Might
    # make this a library function at some point in the future
    _safeApply: (apply = -> undefined) =>
        if @rootScope and (@rootScope.$$phase isnt '$apply' and @rootScope.$$phase isnt '$digest')
            @rootScope.$apply(apply)


    # This behavior of totally destroying the list and rebuilding every time is
    # really inefficient and kind of stupid. For now, it stays, but in the future
    # I'd like to heavily refactor the interaction with the toolbars to make this
    # less disgusting.
    _updateAreas: () =>
        areas = []
        total_acres = 0.0

        for poly, i in @toolbar.getAreas()
            acres = L.GeoUtil.getAcreage(poly)

            if acres? and $.isNumeric(acres)
                acres = parseFloat(acres)
                total_acres += acres
                acres = acres.toFixed 1

            areas.push { acres: acres, poly: poly }

        @areas = areas

        @_safeApply() # make sure everything is updated by calling $apply


    # Gross cropping stuff. This handles cropping the drawn areas to the
    # field's boundary and rebuilding the drawn items
    _cropToField: () =>
        if @toolbar.drawnItems.getLayers().length is 0
            return

        collection = new L.FeatureGroup()
        @toolbar.drawnItems.eachLayer (layer) =>
            curr = @_fieldCrop layer
            collection.addLayer curr

        @toolbar.drawnItems.clearLayers()
        L.GeoUtil.unnestAdd @toolbar.drawnItems, collection
        @toolbar._setStyles()

    _fieldCrop: (area) =>
        f = @field
        curr = L.GeoUtil.combine  area, f, 'intersection'
        curr = L.GeoUtil.readFromJSTS curr #curr.buffer(curr.getArea()*0.003)

        L.GeoUtil.prune(curr) # Sweep out trailing Lines
        return curr

